<template>
    <div>
        <h3>{{ $t("account.profile.title") }}</h3>
        <p class="font-weight-thin">{{ $t("account.profile.subTitle") }}</p>
        <v-container fluid>
            <v-layout column>
                <v-card flat>
                    <v-card-text>                        
                        <v-row>
                            <v-col cols="12" md="6">                                
                                <v-text-field v-model="user.firstName" :label="$t('account.profile.firstName')" required
                                    :rules="[rules.required]"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="user.lastName" :label="$t('account.profile.lastName')" required
                                    :rules="[rules.required]"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12">
                                <v-text-field v-model="user.email" :label="$t('account.profile.email')"
                                    :rules="[rules.required, rules.email]" :append-icon="success ? 'mdi-check' : ''" type="email"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12">
                                <v-text-field v-model="user.phone" :label="$t('account.profile.phone')"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-file-input :rules="rules" accept="image/png, image/jpeg, image/bmp"
                                    :label="$t('account.profile.avatar')" prepend-icon="mdi-camera"></v-file-input>
                                    
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12">                                
                                <v-checkbox v-model="company" :label="$t('account.profile.isCompany')"></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row v-if="company">
                            <v-col cols="12" md="12">
                                <v-text-field v-model="user.companyName" :label="$t('account.profile.companyName')"
                                    required :rules="[rules.required]"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-if="company">
                            <v-col cols="12" md="6">
                                <v-text-field v-model="user.companyCRN" :label="$t('account.profile.companyCrn')"
                                    required :rules="[rules.required]"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="user.companyVAT" :label="$t('account.profile.companyVat')"
                                    required></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-if="company">
                            <v-col cols="12" md="12">
                                <v-text-field v-model="user.street" :label="$t('account.profile.street')" required
                                    :rules="[rules.required]"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-if="company">
                            <v-col cols="12" md="6">
                                <v-text-field v-model="user.town" :label="$t('account.profile.city')" required
                                    :rules="[rules.required]"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="user.zip" :label="$t('account.profile.zip')" required
                                    :rules="[rules.required]"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" :loading="loading" @click.native="update">
                            {{ $t('account.profile.save') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            company: false,
            rules: window.validationRules.getRules(),
            user: {
                id: null,
                email: null,
                firstName: null,
                lastName: null,
                phone: null,
                companyName: null,
                companyCRN: null,
                companyVAT: null,
                street: null,
                town: null,
                zip: null,
                customerInterests: [],
                tenantName: null
            }
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            window.axios
            .get(process.env.VUE_APP_ROOT_API + process.env.VUE_APP_API_ROOT + "/customeraccount/profile")
            .then(response => {
                this.user = response.data;
            })
            .catch(error => {
                console.log(error)
            })
        },
    }
}
</script>